export const GTM_EVENTS = {
    MODAL: 'modal',
    REGISTER_MAIL: 'successfulRegistrationForm',
    REGISTER_FACEBOOK: 'successfulRegistrationFB',
    REGISTER_GOOGLE: 'successfulRegistrationGoogle',
    REGISTER_APPLE: 'successfulRegistrationApple',
};
